import React from 'react';
import { useTranslation } from 'react-i18next';
import { handleTalkToSpecialist } from '../utils/webchat';
import './PricingCard.css';

export default function PricingCard({ plan, highlighted }) {
  const { t } = useTranslation();

  return (
    <div className={`pricing-card ${highlighted ? 'highlighted' : ''}`}>
      {highlighted && <div className="popular-badge">{t('pricing.mostPopular')}</div>}
      <h3 className="plan-name">{plan.name}</h3>
      {plan.description && <p className="plan-description">{plan.description}</p>}
      <div className="plan-price">
        <span className="price-currency">{t('pricing.currency')}</span>
        <span className="price-value">{plan.price}</span>
        <span className="price-period">{t('pricing.perMonth')}</span>
      </div>
      <ul className="plan-features">
        <li>
          ✓{' '}
          {plan.credits === -1
            ? `${t('pricing.unlimited')} ${t('pricing.credits')}`
            : plan.credits != null
              ? `${Number(plan.credits).toLocaleString()} ${t('pricing.credits')}`
              : t('pricing.consult')}
        </li>
        <li>✓ {plan.agents} {t('pricing.agents')}</li>
        <li>✓ {plan.channels} {t('pricing.channels')}</li>
        <li>✓ {plan.members} {t('pricing.members')}</li>
        {plan.featureKeys?.map((key) => (
          <li key={key}>✓ {t(`pricingPage.features.${key}`, { defaultValue: key })}</li>
        ))}
      </ul>
      <button
        type="button"
        onClick={handleTalkToSpecialist}
        className={`plan-cta ${highlighted ? 'cta-primary' : 'cta-ghost'}`}
      >
        {t('pricing.cta')}
      </button>

    </div>
  );
}
